import * as Api from '@ViewModels';
import * as React from 'react';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { SuccessCheckIcon } from '../../svgs/icons/SuccessCheckIcon';

export const useAutomationCardData = (
	automationTemplate: Api.IAutomationTemplateReference,
	isImpersonating = false
) => {
	const userSession = useUserSession();

	let automationName: string = automationTemplate?.status;
	let statusIcon: React.ReactNode = null;
	const trigger = automationTemplate?.draftTrigger || automationTemplate?.publishedTrigger;
	const triggerDescription =
		(trigger as Api.ITagAutomationTrigger)?.tag ||
		Api.VmUtils.Automations.triggers.getAutomationTriggerTitle(trigger, userSession);

	const inProgress = automationTemplate?.stats?.inProgress ?? 0;
	const completed = automationTemplate?.stats?.completed ?? 0;

	const inProgressContactString = `${inProgress} contact${inProgress > 1 || inProgress === 0 ? 's' : ''}`;
	const completedContactString = `${completed} contact${completed > 1 || completed === 0 ? 's' : ''}`;

	const showCompletedButton = completed > 0 && !isImpersonating;

	const showInProgressButton = inProgress > 0 && !isImpersonating;

	const automationId = automationTemplate?.id;

	switch (automationName) {
		case Api.TemplateStatus.Published: {
			statusIcon = <SuccessCheckIcon />;
			automationName = 'Enabled';
			break;
		}
		default: {
			break;
		}
	}

	return {
		automationId,
		automationName,
		completedContactString,
		inProgressContactString,
		showCompletedButton,
		showInProgressButton,
		statusIcon,
		trigger,
		triggerDescription,
	};
};
